import React from 'react';
import { servicesData } from '../data/mock';
import { ArrowRight } from 'lucide-react';

const Services = () => {
  return (
    <section id="servicios" className="py-20 md:py-32 bg-[rgb(var(--bg-secondary))]">
      <div className="container mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <h2 className="heading-1 mb-6 text-[rgb(var(--burgundy-primary))]">
            Áreas de Práctica
          </h2>
          <div className="w-20 h-1 bg-[rgb(var(--burgundy-primary))] mx-auto mb-6"></div>
          <p className="body-large text-[rgb(var(--text-secondary))] max-w-2xl mx-auto">
            Ofrecemos asesoría integral en diversas ramas del derecho, adaptándonos a tus necesidades específicas
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {servicesData.map((service) => (
            <div
              key={service.id}
              className="bg-[rgb(var(--bg-primary))] overflow-hidden hover-lift cursor-pointer group"
            >
              {/* Service Image */}
              <div className="h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
              </div>

              {/* Service Content */}
              <div className="p-6">
                <h3 className="heading-3 mb-3 text-[rgb(var(--burgundy-primary))] group-hover:text-[rgb(var(--burgundy-dark))] transition-colors">
                  {service.title}
                </h3>
                <p className="body-small text-[rgb(var(--text-secondary))] leading-relaxed mb-4">
                  {service.description}
                </p>
                <div className="flex items-center gap-2 text-[rgb(var(--burgundy-primary))] body-small font-medium group-hover:gap-3 transition-all">
                  <span>Conoce más</span>
                  <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
